import { SavingTypes } from "./index.model";

export const getSavingName = () => ({
  type: SavingTypes.GET_SAVING_NAME,
});

export const setEditingID = (data: any) => ({
  type: SavingTypes.SET_EDITING_ID,
  data,
});

export const updateSavingName = (data: any) => ({
  type: SavingTypes.UPDATE_SAVING_NAME,
  data,
});

export const updateLoader = (data: any) => ({
  type: SavingTypes.UPDATE_LOADER,
  data,
});

export const successSavingName = (data: any) => ({
  type: SavingTypes.SAVING_NAME_SUCCESS,
  data,
});

export const failureSavingName = (data: any) => ({
  type: SavingTypes.FAILURE_NAME_SUCCESS,
  data,
});

export const updatedNameId = (data: any) => ({
  type: SavingTypes.UPDATED_NAME_ID,
  data,
});
